<template>
	<div class="ui centered grid">
		<div
			class="six wide tablet six wide computer column"
			:class="$style.padding"
		>
			{{ titulo }}:
		</div>
		<div
			class="six wide tablet ten wide computer column"
			:class="$style.padding"
		>
			<b class="boldFont">{{ valor }}</b>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		titulo: {
			type: String,
			default: '',
		},
		valor: {
			type: [String, Number],
			default: ''
		},
	},
};
</script>

<style lang="scss" module>
@import '@design';
.padding {
	padding-top: 0.6rem !important;
	padding-bottom: 0.6rem !important;
}
</style>
